import React, { useState } from "react";

import axios from "axios";
import { Link } from "react-router-dom";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import LoadingSpinner from "../../components/LoadingSpinner";
import MemboticLogo from "../../assets/MemboticLogo.png"


export default function EmbeddedLoginOrSignUpModal() {
  //styled

  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [loginErr, setLoginErr] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { dispatch } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (e) => {

    setIsLoading(true)
    e.preventDefault();

    if (username.length == 0 || password.length == 0) {
      setLoginErr("Username and password must both be filled in");
      return;
    }

    const loginDetails = { username, password };
    setSubmitting(true);

    try {
      const loginResponse = await axios.post(
        `${ApiConnectionString}/api/users/login/`,
        loginDetails
      );

      if (loginResponse.status === 200) {
        dispatch({ type: "LOGIN", payload: loginResponse.data });
    
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setLoginErr(error.response.data); // Adjusted to handle the error message
      } else {
        // Handle other errors if needed
        console.error(error);
      }
    } finally {
      setSubmitting(false);
      setIsLoading(false)
    }
  };

  
if (isLoading) {
  return (
    <div className="fullscreen-modal-overlay">
      <div className="fullscreen-modal">
        <LoadingSpinner />
      </div>
    </div>
  );
}
else{
  return (
    <div className="fullscreen-modal-overlay">
      <div className="fullscreen-modal">
        <form onSubmit={handleSubmit} className="login-form">
          <div className="text-center">
            {" "}
            <img
              src={MemboticLogo}
              className="logo"
              alt="Membotic"
              title="Membotic"
            />
          </div>

          <p className="text-center">Log in to Membotic to continue</p>
          <label>
            <span>Username or Email:</span>
            <input
              onChange={(e) => setUsername(e.target.value)}
              value={username}
            />
          </label>
          <label>
            <span>Password:</span>
            <input
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
            />
          </label>
          {!submitting ? (
            <button className="btn btn-primary btn-lg">Login</button>
          ) : (
            <button className="btn btn-primary btn-lg" disabled>
              Loading
            </button>
          )}
          <div className="d-flex">
            <p>Not a member?</p>
            <Link to="/Register" className="text-decoration-none mx-2">
              Signup now
            </Link>
          </div>
          {loginErr && <p className="text-danger">{loginErr}</p>}
        </form>
        <div className="send-modal-footer"></div>


      </div>
    </div>
  );
}
}